import { DEFAULT_REWARDER_V2_DECIMAL } from 'config'
import { ecoFarm } from 'config/constants/ecoBoost'
import { MAX_NFT_SELECTABLE } from 'config/constants/farmBoost'
import farms from 'config/constants/farms'
import { NFT_TYPE } from 'config/constants/nftTypes'
import { useTranslation } from 'contexts/Localization'
import { getRewarderV2AddressByPid, useViewEcoBoostFactor } from 'hooks/rewarderV2/useRewarderV2Contract'
import { useMemo } from 'react'
import { isEcoFarmSupported } from 'utils/isNftStakingSupported'

export enum CALCULATE_TYPE {
  STAKE_MORE = 'stakeMoe',
  UN_STAKE = 'unStake',
}

const useNftModalAprDetails = (farmId: number, nftType: NFT_TYPE, nftIds: string[], calculateType: CALCULATE_TYPE) => {
  const { t } = useTranslation()
  const isEcoFarm = isEcoFarmSupported(farmId)
  const currentFarm = farms.find((farm) => farm.pid === farmId)
  const ecoConfig = ecoFarm[currentFarm?.ecoFarm]

  const { data: viewActualEcoBoostFactor } = useViewEcoBoostFactor(getRewarderV2AddressByPid(farmId), farmId, {
    enabled: isEcoFarm,
  })

  const renderContentInfo = useMemo(() => {
    const actualBoostFactor =
      parseFloat(viewActualEcoBoostFactor?.toString() ?? DEFAULT_REWARDER_V2_DECIMAL.toString()) /
        DEFAULT_REWARDER_V2_DECIMAL ?? 1

    let nftBoostFactor = 1

    switch (calculateType) {
      case CALCULATE_TYPE.STAKE_MORE:
        nftBoostFactor = actualBoostFactor + nftIds?.length * ecoConfig?.boostFactorPerNFT
        break

      case CALCULATE_TYPE.UN_STAKE:
      default:
        nftBoostFactor = actualBoostFactor - nftIds?.length * ecoConfig?.boostFactorPerNFT
        break
    }

    let info = {
      maxSelect: 0,
      currentStakingDesc: '',
      currentSelectedDesc: '',
      questionHelperText: '',
      nftBoostFactor: nftBoostFactor.toFixed(1),
    }

    switch (nftType) {
      case NFT_TYPE.ARGO:
        info = {
          ...info,
          maxSelect: ecoConfig?.maxStakedNum ?? 0,
          currentStakingDesc: t('Current staking NFTs'),
          currentSelectedDesc: t('NFTs selected to stake'),
          questionHelperText: t('NFT boost factor will be determined by the number of NFTs staked.'),
        }
        break

      case NFT_TYPE.MINER_MOLE:
      default:
        info = {
          ...info,
          maxSelect: MAX_NFT_SELECTABLE,
          currentStakingDesc: t('Current staking Moles'),
          currentSelectedDesc: t('Moles selected to stake'),
          questionHelperText: t(
            'NFT boost factor will be determined by the rarity level and number of VVS Miner Moles staked.',
          ),
        }
        break
    }

    return info
  }, [
    calculateType,
    ecoConfig?.boostFactorPerNFT,
    ecoConfig?.maxStakedNum,
    nftIds?.length,
    nftType,
    t,
    viewActualEcoBoostFactor,
  ])

  return renderContentInfo
}

export default useNftModalAprDetails
